export const useUploadFile = () => {
  type FileType =
    | "AVATAR"
    | "RESUME"
    | "IDENTITY"
    | "ACTIVITY"
    | "ACTIVITY_BANNER"
    | "SITE_BANNER";
  const uploadFile = async (
    file: File,
    type: FileType,
  ): Promise<{ uuid: string; url: string }> => {
    const { $customFetch } = useNuxtApp();
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("provider", "local");
      formData.append("type", type);

      const response = await $customFetch<{
        uuid: string;
        presignedURL: {
          url: string;
        };
      }>("/files/uploads", {
        method: "POST",
        body: formData,
      });
      return {
        uuid: response.uuid,
        url: response.presignedURL.url,
      };
    } catch (error) {
      console.error(`Error uploading ${type}:`, error);
      throw error;
    }
  };

  return { uploadFile };
};
